export const resolveAsset = (value: unknown): string => {
  if (typeof value === "string") return value;
  if (value instanceof URL) return value.toString();
  if (value && typeof value === "object" && "default" in value) {
    return String((value as { default: unknown }).default ?? "");
  }
  if (value && typeof value === "object") {
    if ("url" in value) {
      return String((value as { url: unknown }).url ?? "");
    }
    if ("href" in value) {
      return String((value as { href: unknown }).href ?? "");
    }
    if ("src" in value) {
      return String((value as { src: unknown }).src ?? "");
    }
    if ("path" in value) {
      return String((value as { path: unknown }).path ?? "");
    }
    return String(value);
  }
  return "";
};

const basename = (value: string) => value.split("/").pop() || value;

const withoutExtension = (value: string) => value.replace(/\.[^/.]+$/, "");

export const resolveAssetMap = (assets: unknown) => {
  const resolved: Record<string, string> = {};
  if (!assets || typeof assets !== "object") return resolved;
  Object.keys(assets).forEach((key) => {
    const assetUrl = resolveAsset((assets as Record<string, unknown>)[key]);
    resolved[key] = assetUrl;
    const base = basename(key);
    resolved[base] = assetUrl;
    resolved[withoutExtension(base)] = assetUrl;
  });
  return resolved;
};

export const mergeAssetMaps = (...maps: Array<Record<string, string>>): Record<string, string> =>
  Object.assign({}, ...maps);

export const getAssetUrl = (map: Record<string, string>, key?: string): string => {
  if (!key) return "";
  return map[key] ?? "";
};
